function cleanEmptyValues(obj) {
    const clean = { ...obj };
    Object.keys(obj).forEach((key) => obj[key] === undefined ||
        (typeof obj[key] === "string" && obj[key]?.length === 0) ||
        (Array.isArray(obj[key]) &&
            obj[key]?.length === 1 &&
            typeof obj[key]?.[0] === "undefined")
        ? delete clean[key]
        : {});
    return clean;
}
function brandsafetyfyValue(value) {
    if (typeof value === "undefined") {
        return value;
    }
    return `${value}-bs`;
}
// Encodes , and = with url encoding
function encodeSalesforceValue(value) {
    if (typeof value === "undefined") {
        return value;
    }
    if (typeof value === "string") {
        return value.replace(/,/g, "%2C").replace(/=/g, "%3D");
    }
    return value;
}
function stringifyValue(value) {
    if (typeof value === "number" || typeof value === "bigint") {
        return value.toString(10);
    }
    if (typeof value === "boolean") {
        return value === true ? "true" : "false";
    }
    return value;
}
export { cleanEmptyValues, brandsafetyfyValue, encodeSalesforceValue, stringifyValue, };
//# sourceMappingURL=dmp-format.js.map